import { render, staticRenderFns } from "./calendar-add-attributes-form.vue?vue&type=template&id=39133b60&scoped=true"
import script from "./calendar-add-attributes-form.vue?vue&type=script&lang=js"
export * from "./calendar-add-attributes-form.vue?vue&type=script&lang=js"
import style0 from "./calendar-add-attributes-form.vue?vue&type=style&index=0&id=39133b60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39133b60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39133b60')) {
      api.createRecord('39133b60', component.options)
    } else {
      api.reload('39133b60', component.options)
    }
    module.hot.accept("./calendar-add-attributes-form.vue?vue&type=template&id=39133b60&scoped=true", function () {
      api.rerender('39133b60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin_settings/components/calendars/calendar-add-attributes-form.vue"
export default component.exports